export const getCheckedApiKeys = ({ apiKeys, data }) => {
  return apiKeys?.length ? apiKeys : data.filter((item) => !!item.id).map(({ id }) => id);
};

export const getItemNameById = ({ id, data }) => {
  if (!id || !data || !data.length) return null;

  const item = data.find((item) => item?.id === id);

  return item?.name || `${id}`;
};
